import styled from '@emotion/styled';
import { mediaQuery } from '@styles/index';
import { NTA_COLORS } from '../../constants';
import { ntaHeaderLabelCss } from '../../typography';

const LanguageBlock = styled.div`
  width: 260px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
`;

const LanguageLabel = styled.p`
  margin: 0;
  color: ${NTA_COLORS.white};
  white-space: nowrap;
  ${ntaHeaderLabelCss}

  ${mediaQuery.uptoMobile} {
    white-space: normal;
  }
`;

const LanguageField = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 16px;
  border: 1px solid ${NTA_COLORS.divider};
  border-radius: 8px;
  background: ${NTA_COLORS.white};
`;

const LanguageSelect = styled.select`
  flex: 1;
  height: 100%;
  border: none;
  background: transparent;
  color: ${NTA_COLORS.textPrimary};
  appearance: none;
  padding-right: 28px;
  cursor: pointer;
  ${ntaHeaderLabelCss}
`;

const Chevron = styled.span`
  position: absolute;
  right: 12px;
  pointer-events: none;
  width: 24px;
  height: 24px;
  background: center / contain no-repeat
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M7 10l5 5 5-5' stroke='%233C4852' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
`;

const NtaHeaderLanguageSelect = ({
  languages = [],
  selectedLanguage,
  onLanguageChange,
  label = 'Choose your default language'
}) => {
  if (!languages.length) return null;

  return (
    <LanguageBlock>
      <LanguageLabel>{label}</LanguageLabel>
      <LanguageField>
        <LanguageSelect
          value={selectedLanguage?.code ?? languages[0]?.code ?? ''}
          onChange={(e) => onLanguageChange?.(e.target.value)}
        >
          {languages.map((lang) => (
            <option key={lang.code} value={lang.code}>
              {lang.display_name}
            </option>
          ))}
        </LanguageSelect>
        <Chevron aria-hidden />
      </LanguageField>
    </LanguageBlock>
  );
};

export default NtaHeaderLanguageSelect;
